import type { AuthRepository, TokenPair } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { uuidValueObject } from '@contexts/shared/domain';

export type SuplantUserInput = {
	userId: string;
};

export type SuplantUserUseCase = UseCase<SuplantUserInput, TokenPair>;

export function suplantUserBuilder(authRepository: AuthRepository): SuplantUserUseCase {
	return async function suplantUser(input: SuplantUserInput): Promise<TokenPair> {
		const userId = uuidValueObject().validate('userId', input.userId);

		return authRepository.suplantUser(userId);
	};
}
